module.exports = __webpack_public_path__ + "img/distrust.7f34562e.png";